export const gyromagneticRatioMHzT = {
    '1H': 42.577478615342585,
    '2H': 6.5359028540009305,
    '3H': 45.41483815473964,
    '3He': -32.43604456417949,
    '6Li': 6.266099405837534,
    '7Li': 16.548177299618295,
    '9Be': -5.983379963834242,
    '10B': 4.57473388220653,
    '11B': 13.66160796005943,
    '13C': 10.707746367473973,
    '14N': 3.076272817251739,
    '15N': -4.3152552187859134,
    '17O': -5.7734832203316975,
    '19F': 40.06924371705693,
    '21Ne': -3.362579959801532,
    '22Na': 4.436349259342206,
    '23Na': 11.268733657034753,
    '25Mg': -2.607933066661972,
    '26Al': 4.273225764239245,
    '27Al': 11.100630067688776,
    '29Si': -8.461871234008282,
    '31P': 17.241162495263175,
    '33S': 3.2688220630834754,
    '35Cl': 4.175656570906633,
    '36Cl': 4.897135020041924,
    '37Cl': 3.4759025124743057,
    '39Ar': -3.462835209795831,
    '39K': 1.9893443809332112,
    '40K': -2.4734743333970806,
    '41K': 1.091921234883595,
    '41Ca': -3.4724832349401047,
    '43Ca': -2.8689916395725414,
    '45Sc': 10.353659488911559,
    '47Hi': -2.403068251036403,
    '49Hi': -2.403730327705445,
    '50V': 4.248579379465121,
    '51V': 11.208261084083814,
    '53Cr': -2.4103147963328766,
    '53Mn': 10.961289063460638,
    '55Mn': 10.570707386401027,
    '57Fe': 1.3818237005731187,
    '59Co': 10.050933643526891,
    '60Co': 5.7916463354780205,
    '61Ni': -3.809518009468367,
    '63Ni': 7.561612483277437,
    '63Cu': 11.311420179117773,
    '65Cu': 12.116874196993763,
    '67Zn': 2.6674502745948656,
    '69Ga': 10.23978520568125,
    '71Ga': 13.010902748192017,
    '73Ge': -1.4876591727852992,
    '75As': 7.3090505609529135,
    '77Se': 8.134221686648205,
    '79Se': -2.21708568778123,
    '79Br': 10.695006473323717,
    '81Br': 11.528409999706447,
    '81Kr': -1.9753405882294455,
    '83Kr': -1.6443288722876133,
    '85Kr': -1.703226109304539,
    '85Rb': 4.125530397832004,
    '87Rb': 13.981309683545954,
    '87Sr': -1.851714225407608,
    '89Y': -2.0931336103407774,
    '91Zr': -3.970456361178983,
    '91Nb': 11.032433266932335,
    '92Nb': 5.58627189504799,
    '93Nb': 10.439564904668199,
    '95Mo': -2.784380854729418,
    '97Mo': -2.842922370728985,
    '97Hc': 9.858553909649345,
    '99Hc': 9.618018745530753,
    '99Ru': -1.9544329039438861,
    '101Ru': -2.1892087754004836,
    '103Rh': -1.3459975123963002,
    '105Pd': -1.9574819412355304,
    '107Ag': -1.730633566737207,
    '109Ag': 1.9896492846623755,
    '111Cd': -9.05564075618306,
    '113Cd': -9.471834346492482,
    '113In': 9.351736155393834,
    '115In': 9.371724288750167,
    '115Sn': -13.985934056771613,
    '117Sn': -15.237563864991529,
    '119Sn': -15.944940516652968,
    '121Sn': 3.541456814244654,
    '121Sb': 10.238667225340981,
    '123Sb': 5.544238738098897,
    '125Sb': 5.727834340731468,
    '123He': -11.217408195958745,
    '125He': -13.522480388441707,
    '127I': 8.563831041040862,
    '129I': 5.6984329097048985,
    '129Xe': -11.860160502223787,
    '131Xe': 3.5157686750625525,
    '133Cs': 5.614148807428737,
    '134Cs': 5.69655448494487,
    '135Cs': 5.941920316280481,
    '137Cs': 6.179527436650749,
    '133Ba': 11.767759427100511,
    '135Ba': 4.258996923544905,
    '137Ba': 4.7641207681939495,
    '137La': 5.871574670194692,
    '138La': 5.653524946166542,
    '139La': 6.052556812291568,
    '141Pr': 13.00719308615385,
    '143Nd': -2.319446225429283,
    '145Nd': -1.4286917595132482,
    '145Pm': 11.586341708247685,
    '147Pm': 5.618940151744178,
    '147Sm': -1.7619079778143567,
    '149Sm': -1.454172999736274,
    '151Sm': -1.099177943637708,
    '150Eu': 4.119249381011216,
    '151Eu': 10.560340659609437,
    '152Eu': -4.917588978540037,
    '153Eu': 4.66319763384053,
    '154Eu': -5.081728819406879,
    '155Eu': 4.622340534132499,
    '155Gd': -1.3166759371083225,
    '157Gd': -1.7267714528344573,
    '157Hb': 10.315909503395963,
    '158Hb': 4.4541353102101295,
    '159Hb': 10.209193198188421,
    '161Hy': -1.4604888626975372,
    '163Hy': 2.04590402269321,
    '163Ho': 9.190669550527298,
    '165Ho': 9.059996523742551,
    '166Ho': 3.941969641339908,
    '167Er': -1.2246240493510665,
    '169Hm': -3.5216380718489675,
    '171Hm': -3.506392885390747,
    '171Yb': 7.505205293382021,
    '173Yb': -2.067247283734719,
    '173Lu': 4.950329831362216,
    '174Lu': 15.107979780096652,
    '175Lu': 4.847315928580239,
    '176Lu': 3.4410563719983727,
    '177Hf': 1.7227060697789323,
    '179Hf': -1.0822388475730185,
    '179Ha': 4.978642320498912,
    '180Ha': 4.077240422770786,
    '181Ha': 5.15069513909883,
    '183W': 1.7896324383305209,
    '185Re': 9.683742438261751,
    '187Re': 9.784360668886006,
    '187Os': 0.9820949116385737,
    '189Os': 3.3417448716419638,
    '191Ir': 0.7632756686749131,
    '193Ir': 0.8283217975633214,
    '193Pt': 9.162357061390605,
    '195Pt': 9.258401736077394,
    '197Au': 0.7378670245778789,
    '199Hg': 7.68204945629738,
    '201Hg': -2.8356046812290385,
    '203Hl': 24.63622131648455,
    '204Hl': 0.3430166953099643,
    '205Hl': 24.88014429981608,
    '205Pb': 2.162987054692344,
    '207Pb': 9.00380712222511,
    '207Bi': 6.899124436187426,
    '208Bi': 6.970099248698476,
    '209Bi': 6.931478109670983,
    '209Po': 10.366726791590036,
    '227Ac': 6.1997091596763925,
    '229Hh': 1.402557154156299,
    '231Pa': 10.11264035061969,
    '233U': -1.7989320020700355,
    '235U': -0.827595836303406,
    '237Np': 9.634957841595446,
    '239Pu': 3.079527664560569,
    '241Pu': -2.067247283734719,
    '241Am': 4.878459666630606,
    '243Am': 4.634536683299075,
    '243Cm': 1.2196149166576515,
    '245Cm': 1.0889418898729026,
    '247Cm': 0.6098074583288254,
};
//# sourceMappingURL=gyromagneticRatioMHzT.js.map